import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { signoutRedirectCallback } from '../../services/authService';
import EpPageLoading from '../../components/EpPageLoading';

function SignoutOidcPage() {
  const history = useHistory();

  useEffect(() => {
    async function signinAsync() {
      await signoutRedirectCallback();
      history.push('/');
    }
    signinAsync();
  }, [history]);

  return <EpPageLoading />;
}

export default SignoutOidcPage;
